import { render, staticRenderFns } from "./ReviewStarsNew.vue?vue&type=template&id=4a1aea8f&scoped=true"
import script from "./ReviewStarsNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviewStarsNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReviewStarsNew.vue?vue&type=style&index=0&id=4a1aea8f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1aea8f",
  null
  
)

export default component.exports